import React, { useEffect } from 'react';

const Loading = ({ message }) => {
  useEffect(()=>{
    console.log("Inside Loading Component");
  },[]);
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent black background
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        backdropFilter: 'blur(5px)', // Blur the background
      }}
    >
      <div className="text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <div className="mt-3 text-white">{message}</div>
      </div>
    </div>
  );
};

export default Loading;